<div *ngIf="templateFieldsCatalog?.length > 1">
  <ppt-actions-toolbar
    [reportData]="reportData"
    [currentView]="currentView"
    [templates]="templateFieldsCatalog"
    [requiresRecordNavigation]="false"
    [isUKFeaturesEnabled]="isUKFeaturesEnabled"
    (templateChange)="onTemplateSelected($event)"
  ></ppt-actions-toolbar>
</div>

<rep-table-info
  [isPDF]="isPDF"
  [reportData]="reportData"
  [groupsToDisplay]="bodyGroups"
  [headerGroups]="headerGroups"
  [currentView]="currentView"
  [templateProjectionMap]="templateProjectionMap"
  [reportLocale]="reportLocale"
  [reportOptions]="reportOptions"
  (reportUpdateClick)="reportUpdateClick.emit($event)"
  (removeRecord)="removeRecordFromReport($event)"
  (reportReordered)="reportReordered.emit($event)"
  [confidentialityTmpl]="confidentialityTmpl"
></rep-table-info>
